import React from 'react'

const ValidationText = ({name,...props}) => {
  let text = props?.validations?.optionsError ? props?.validations?.optionsError : `${name} Is Required!`;
  return (   
  <div className="invalid-feedback tool_tip d-flex align-items-center gap-1" style={{ display: "block" }}>
    <i className="bi bi-info-circle-fill fs-10"></i>
    <p className="fs-9 text-white text">{text}</p>
    </div>
  )
}

export default ValidationText